import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from "@angular/router";
import {SharedMaterialModule} from 'app/shared/shared-material.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';

import {FlexLayoutModule} from '@angular/flex-layout';
// import { CommonDirectivesModule } from './sdirectives/common/common-directives.module';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {LockscreenComponent} from './lockscreen/lockscreen.component';
import {SigninComponent} from './signin/signin.component';
import {SignupComponent} from './signup/signup.component';
import {SessionsRoutes} from './sessions.routing';
import {NotFoundComponent} from './not-found/not-found.component';
import {ErrorComponent} from './error/error.component';
import {Signup2Component} from './signup2/signup2.component';
import {Signup3Component} from './signup3/signup3.component';
import {Signup4Component} from './signup4/signup4.component';
import {Signin3Component} from './signin3/signin3.component';
import {Signin4Component} from './signin4/signin4.component';
import {Signin2Component} from './signin2/signin2.component';
import {NewPasswordComponent} from './new-password/new-password.component';
import {CompanySignupComponent} from './company-signup/company-signup.component';
import {CompanySigninComponent} from './company-signin/company-signin.component';
import {SessionsUserGuard} from '../../shared/guards/sessions-user.guard';
import {SessionsCompanyGuard} from '../../shared/guards/sessions-company.guard';
import {UserLoginGuard} from '../../shared/guards/user-login.guard';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import {SharedComponentsModule} from '../../shared/components/shared-components.module';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedMaterialModule,
        FlexLayoutModule,
        PerfectScrollbarModule,
        RouterModule.forChild(SessionsRoutes),
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SharedComponentsModule
    ],
    declarations: [
        ForgotPasswordComponent,
        NewPasswordComponent,
        LockscreenComponent,
        SigninComponent,
        SignupComponent,
        NotFoundComponent,
        ErrorComponent,
        Signup2Component,
        Signup3Component,
        Signup4Component,
        Signin3Component,
        Signin4Component,
        Signin2Component,
        CompanySignupComponent,
        CompanySigninComponent,
        ForbiddenComponent
    ],
    providers: [
      SessionsUserGuard,
      SessionsCompanyGuard,
      UserLoginGuard
    ]
})
export class SessionsModule {
}
